module.exports = __webpack_public_path__ + "img/classic_4.4151448b.jpg";